import * as ReactionsAPI from '../api/Reactions.api';
import ReactionsConstants from 'Shared/constants/Reactions.constants';
import normalizer from 'Shared/utils/normalizeJSON/normalizer';

import ReactionSchema from 'Shared/utils/normalizeJSON/schemas/Reaction.schema';

export const createReactionSuccess = payload => ({
  type: ReactionsConstants.Actions.CREATE_REACTION_SUCCESS,
  payload,
});

export const deleteReactionSuccess = payload => ({
  type: ReactionsConstants.Actions.DELETE_REACTION_SUCCESS,
  payload,
});

export const createReaction = ({
  reaction,
  reactionable_type,
  reactionable_id,
}: {
  reaction: string;
  reactionable_type: 'feedback';
  reactionable_id: string;
}) => dispatch => {
  return ReactionsAPI.createReaction({ data: reaction, reactionable_type, reactionable_id }).then(response => {
    dispatch(createReactionSuccess(normalizer(ReactionSchema, response.data)));
    return response;
  });
};

export const deleteReaction = ({ reactionSlug }: { reactionSlug: string }) => dispatch => {
  return ReactionsAPI.deleteReaction(reactionSlug).then(response => {
    dispatch(deleteReactionSuccess({ reactionSlug }));
    return response;
  });
};
